import styled from "styled-components";

export const BetSelections = styled.div``;

export const BetSelectionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: var(--fd-space-space-2);
`;
